import React from 'react';
import './AboutModal.css'; // Reuse the same CSS

/**
 * PrivacyPolicyModal Component
 * 
 * Modal component for the Privacy Policy information that opens when clicking the Privacy Policy link
 */
const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  // Close the modal when clicking outside
  const handleOutsideClick = (e) => {
    if (e.target.className.includes('modal')) {
      onClose();
    }
  };

  return (
    <div 
      id="privacyPolicyModal" 
      className={`modal ${isOpen ? 'modal-open' : 'modal-closed'}`}
      onClick={handleOutsideClick}
    >
      {/* Modal content */}
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>

        <h2>Privacy Policy</h2>

        <p>
          Last Updated: April 25, 2023
        </p>

        <h4>Introduction</h4>
        <p>
          This Privacy Policy describes how we collect, use, and handle your information when you use marc.tools. We're committed to protecting your privacy and being transparent about how we use your data.
        </p>

        <h4>Information We Collect</h4>
        <p>
          <strong>Usage Data:</strong> We collect information on how you interact with our site, including pages visited, time spent on each page, and features used.
        </p>
        <p>
          <strong>Device Information:</strong> We collect information about your device, including browser type, IP address, and operating system to optimize your experience.
        </p>
        <p>
          <strong>Cookies:</strong> We use cookies to enhance your experience and analyze usage patterns. You can control cookie settings through your browser preferences.
        </p>

        <h4>How We Use Information</h4>
        <p>
          We use the information we collect to:
        </p>
        <ul>
          <li>Provide, maintain, and improve our tools and services</li>
          <li>Understand how users interact with our site to enhance user experience</li>
          <li>Develop new features based on user behavior and feedback</li>
          <li>Protect against unauthorized access and security threats</li>
        </ul>

        <h4>Data Sharing and Disclosure</h4>
        <p>
          We do not sell your personal information to third parties. We may share information with:
        </p>
        <ul>
          <li>Service providers who help us operate the site</li>
          <li>When required by law or to protect our rights</li>
        </ul>

        <h4>Your Rights</h4>
        <p>
          You have the right to:
        </p>
        <ul>
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your information where applicable</li>
          <li>Opt out of certain data collection practices</li>
        </ul>

        <h4>Contact Us</h4>
        <p>
          If you have questions about this Privacy Policy or our data practices, please contact us at &#104;&#101;&#108;&#108;&#111;&#064;&#109;&#097;&#114;&#099;&#046;&#108;&#121;.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal; 
 